var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentActors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 24.9997V74.9997C87.5 77.2913 89.375 79.1663 91.6667 79.1663C93.9584 79.1663 95.8334 77.2913 95.8334 74.9997V24.9997C95.8334 22.708 93.9584 20.833 91.6667 20.833C89.375 20.833 87.5 22.708 87.5 24.9997ZM75 79.1663C77.2917 79.1663 79.1667 77.2913 79.1667 74.9997V24.9997C79.1667 22.708 77.2917 20.833 75 20.833C72.7084 20.833 70.8334 22.708 70.8334 24.9997V74.9997C70.8334 77.2913 72.7084 79.1663 75 79.1663ZM58.3334 20.833H8.33335C6.04169 20.833 4.16669 22.708 4.16669 24.9997V74.9997C4.16669 77.2913 6.04169 79.1663 8.33335 79.1663H58.3334C60.625 79.1663 62.5 77.2913 62.5 74.9997V24.9997C62.5 22.708 60.625 20.833 58.3334 20.833ZM33.3334 32.2913C38.5 32.2913 42.7084 36.4997 42.7084 41.6663C42.7084 46.833 38.5 51.0413 33.3334 51.0413C28.1667 51.0413 23.9584 46.833 23.9584 41.6663C23.9584 36.4997 28.1667 32.2913 33.3334 32.2913ZM52.0834 70.833H14.5834V67.708C14.5834 61.458 27.0834 58.333 33.3334 58.333C39.5834 58.333 52.0834 61.458 52.0834 67.708V70.833Z",
    fill: "#F84343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentActors);
export default __webpack_public_path__ + "static/media/recent_actors.5be374efbaa1856ac88ea94d0dc09d9c.svg";
export { ForwardRef as ReactComponent };